import { render, staticRenderFns } from "./WorkIconColorNoSelection.vue?vue&type=template&id=2c571466"
import script from "./WorkIconColorNoSelection.vue?vue&type=script&lang=js"
export * from "./WorkIconColorNoSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports